var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.buckets),function(bucket,index){return [_c('checkbox',{key:index,class:{ 'bg-white-light': !_vm.isEven(index), 'px-3': !_vm.filter.collapsed },attrs:{"bucket":bucket,"count":bucket.count,"filterName":_vm.filterName,"isLocked":_vm.isLocked},on:{"selected":_vm.handleCheckbox}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }